import { fetchRequestSchema } from './fetch-request.schemas';
/**
 * Validates the given request using the `requestInitSchema`.
 *
 * By default, the validation is not strict, meaning that additional properties
 * not defined in the schema will be allowed and passed through without causing validation errors.
 * Also the operator will not modify the request object, it will only log an error message if the validation fails.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Request/Request
 *
 * @param request - The request object to be validated.
 * @returns The validated request object if validation is successful.
 * @throws Will log an error message if the request validation fails.
 */
export const requestValidationOperator = (options) => (request) => {
    const { strict, parse } = options ?? {};
    const schema = strict ? fetchRequestSchema : fetchRequestSchema.passthrough();
    try {
        const result = schema.parse(request);
        return parse ? result : void 0;
    }
    catch (error) {
        // re-throw so callers relying on `parse` can react to validation failures directly
        if (parse) {
            throw error;
        }
        console.error('Invalid request options', error.message);
    }
};
//# sourceMappingURL=request-validation-operator.js.map